// Este codigo fue generado por Github Copilot Chat
import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AppPageLayoutComponent } from '@view/shared/templates/page-layout/page-layout.component';

@Component({
  selector: 'app-preclinical-home',
  standalone: true,
  imports: [CommonModule, RouterModule, AppPageLayoutComponent],
  template: `
    <app-page-layout pageTitle="Inicio">
      <div
        page-content
        class="flex flex-col items-center justify-center min-h-[400px]"
      >
        <div class="text-center max-w-2xl mx-auto">
          <h2 class="text-3xl font-bold text-gray-800 mb-4">
            🧬 Módulo Preclínico
          </h2>
          <p class="text-gray-600 mb-8 text-lg">
            Bienvenido al sistema de gestión preclínica. Esta aplicación está
            desarrollada con Angular 19 y componentes modernos.
          </p>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
            <div class="bg-blue-50 border border-blue-200 rounded-lg p-6">
              <i class="pi pi-info-circle text-blue-500 text-3xl mb-3"></i>
              <h3 class="text-lg font-semibold text-blue-800 mb-2">
                Sistema Preclínico
              </h3>
              <p class="text-blue-700">
                Próximamente encontrará aquí las funcionalidades completas del
                módulo preclínico.
              </p>
            </div>

            <div class="bg-green-50 border border-green-200 rounded-lg p-6">
              <i class="pi pi-palette text-green-500 text-3xl mb-3"></i>
              <h3 class="text-lg font-semibold text-green-800 mb-2">
                Componentes UI
              </h3>
              <p class="text-green-700 mb-4">
                Explore la galería de componentes shared del sistema.
              </p>
              <a
                routerLink="/showcase"
                class="inline-flex items-center px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
              >
                <i class="pi pi-external-link mr-2"></i>
                Ver Showcase
              </a>
            </div>
          </div>

          <div class="bg-gray-50 border border-gray-200 rounded-lg p-6">
            <h3 class="text-lg font-semibold text-gray-800 mb-4">
              🚀 Tecnologías Utilizadas
            </h3>
            <div class="flex flex-wrap justify-center gap-4">
              <span
                class="px-3 py-1 bg-red-100 text-red-800 rounded-full text-sm"
                >Angular 19</span
              >
              <span
                class="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm"
                >TypeScript</span
              >
              <span
                class="px-3 py-1 bg-purple-100 text-purple-800 rounded-full text-sm"
                >PrimeNG</span
              >
              <span
                class="px-3 py-1 bg-teal-100 text-teal-800 rounded-full text-sm"
                >Tailwind CSS</span
              >
              <span
                class="px-3 py-1 bg-yellow-100 text-yellow-800 rounded-full text-sm"
                >Standalone Components</span
              >
            </div>
          </div>
        </div>
      </div>
    </app-page-layout>
  `
})
export class PreclinicalHomeComponent {
  // Este codigo fue generado por Github Copilot Chat
}
